import React from 'react';
import PropTypes from 'prop-types';

const InputForm = props => {

    let parentClassName = ( props.parentClassName )  ? props.parentClassName : '';
    let labelClassName = ( props.labelClassName )  ? props.labelClassName : '';
    let className = ( props.className )  ? props.className : '';
    let placeholder = ( props.placeholder )  ? props.placeholder : '';
    let formik = ( props.formik ) ? props.formik : ''
    let withFormik = ( props.withFormik ) ? {...formik.getFieldProps(props.name)} : ''
    let inputRef = ( props.inputRef ) ? props.inputRef : null
    let value = ( props.withFormik == false ) ? {
        value: props.value || '',

    } : undefined;

    return (
        <div className={`form-group ${parentClassName}`}>
            {
                props?.label && (
                    <label htmlFor={props.id} className={`control-label ${labelClassName}`}>{props.label}</label>
                )
            }
            <input 
                className={`form-control ${className}`}
                type={props.type}
                id={props.id}
                placeholder={placeholder} 
                min={props.type == "date" && props.isPastDateDisabled ? new Date().toISOString().split('T')[0] : null}
                name={props.name}
                ref={inputRef}
                disabled={props.disabled}
                onChange= {props.onChange ? (e => {props.onChange(e)}) : null}
                {...withFormik}
                onBlur={props.onBlur}
                value={formik?.values[props?.id]}
                required={props.required}
                {...value}
            />
            { props.withFormik && formik && formik.touched[props.name] && formik.errors[props.name] ? (
                    <div className={`help-block text-red-400 mt-2 ${props.helpBlockClass}`}>{formik.errors[props.name]}</div>
            ) : null}
            { props?.helpBlockText ? (
                    <div className={`help-block mt-2 ${props.helpBlockClass}`}>{props.helpBlockText}</div>
            ) : null}
        </div>
    );
};

InputForm.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,

    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,

    withFormik: PropTypes.bool,
    formik: PropTypes.object,
    
    parentClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    helpBlockClassName: PropTypes.string,
};

export default InputForm;